import { Component, EventEmitter, input, Output } from "@angular/core";
import { ILatLng } from "polydraw";

@Component({
    selector: "drawn-list-item",
    templateUrl: "./drawn-list-item.component.html",
    styleUrl: "./drawn-list-item.component.scss",
})
export class DrawnListItemComponent {
    polygon = input<ILatLng[][]>();
    @Output() onRemove = new EventEmitter<ILatLng[][]>();

    onClickEvent(): void {}
}
